// extracted by mini-css-extract-plugin
export var button = "styles-module--button--953a2";
export var compact = "styles-module--compact--60124";
export var katacodaIcon = "styles-module--katacodaIcon--05aad";